/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["table[_ngcontent-%COMP%]   label.btn[_ngcontent-%COMP%]{padding:8px 12px;margin-right:10px}.btn[_ngcontent-%COMP%]   span.glyphicon-ok[_ngcontent-%COMP%], table[_ngcontent-%COMP%]   .btn[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{display:none}.btn[_ngcontent-%COMP%]   span.glyphicon-remove[_ngcontent-%COMP%], .btn.active[_ngcontent-%COMP%]   span.glyphicon[_ngcontent-%COMP%]{display:block}.btn.active[_ngcontent-%COMP%]   span.glyphicon-remove[_ngcontent-%COMP%]{display:none}\n/*# sourceMappingURL=keyaccount-edit.component.css.map*/"];
export { styles as styles };
